'use client';

import { DesignSystemProvider } from '@prismo-io/design-system/provider';
import { ToolsPalettes } from '@prismo-io/design-system/themes';
import { SessionListener } from '@prismo-io/feature-auth/session-listener';
import { AppType, type LanguageCodeT } from '@prismo-io/schemas';
import { NpsSurveyProvider } from '@prismo-io/tracking';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  sessionAccessToken?: string;
  locale: LanguageCodeT;
};

export const GlobalProviders: FC<Props> = (props) => {
  const { children } = props;

  return (
    <>
      <SessionListener />
      <DesignSystemProvider
        theme={ToolsPalettes.light}
        options={{ key: 'mui' }}
      >
        <NpsSurveyProvider app={AppType.Enum.TOOLS}>
          {children}
        </NpsSurveyProvider>
      </DesignSystemProvider>
    </>
  );
};
